import { render } from "./groups.svg?vue&type=template&id=19f916d4?inline"
const script = {}
script.render = render

export default script